<template>
  <div v-if="storageReceipt" class="card card-custom overflow-hidden">
    <div class="card-body p-0">
      <!-- begin: header-->
      <div class="row justify-content-center px-8 px-md-0 py-6 py-md-10">
        <div class="col-md-9">
          <div
            class="d-flex justify-content-between pb-10 pb-md-20 flex-column flex-md-row"
          >
            <h1 class="display-6 font-weight-boldest mt-2 mb-8">
              کد
              <span class="btn btn-outline-primary font-size-lg p-2 px-5">
                {{ storageReceipt.id }}
              </span>
              <span class="mt-3 d-block opacity-70 font-size-xs"></span>
            </h1>
            <div class="d-flex flex-column align-items-md-end px-0">
              <div class="max-w-150px text-center">
                <img
                  class="mx-auto w-100"
                  src="/media/logos/logo.png"
                  alt="mirol"
                />
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mb-15">
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">خریدار</span>
              <span class="opacity-70">
                {{ getFullName }}
              </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">فروشنده</span>
              <span class="opacity-70 text-nowrap">
                تکیه - سروس پخش زنده اینترنتی
              </span>
            </div>
            <div class="d-flex flex-column flex-root">
              <span class="font-weight-bolder mb-2">تاریخ</span>
              <span dir="ltr" class="opacity-70 text-nowrap font-family-base">
                {{ formatDate(storageReceipt["created_at"]) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- end: header-->

      <!-- begin: body-->
      <!-- end: body-->

      <!-- begin: footer-->
      <div
        class="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0"
      >
        <div class="col-md-9">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th
                    class="font-weight-bold text-muted text-center text-uppercase"
                  >
                    حجم
                  </th>
                  <th
                    class="font-weight-bold text-muted text-center text-uppercase"
                  >
                    مجموع (ریال)
                  </th>
                  <th
                    class="font-weight-bold text-muted text-center text-uppercase"
                  >
                    مبلغ قابل پرداخت (ریال)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="font-weight-bolder">
                  <td class="text-center" dir="ltr">
                    {{
                      storageReceipt.items
                        ? bytesToHuman(storageReceipt.items.size)
                        : ""
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      storageReceipt.items
                        ? numberFormat(storageReceipt.items.sum)
                        : ""
                    }}
                  </td>
                  <td
                    class="text-danger font-size-h3 font-weight-boldest text-center"
                  >
                    {{ numberFormat(storageReceipt.total) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end: footer-->

      <!-- begin: action-->
      <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
        <div class="col-md-9">
          <div class="d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-primary print-button font-weight-bold"
              onclick="window.print();"
            >
              چاپ رسید
            </button>
          </div>
        </div>
      </div>
      <!-- end: action-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_STORAGE_RECEIPT } from "@/core/services/store/receipts/storage.module";
import { mapGetters } from "vuex";

export default {
  name: "storageReceiptsShow",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "رسیدها", route: { name: "receipts-storage-index" } },
      { title: ` رسید شماره ${this.$route.params.id}` }
    ]);
    this.$store
      .dispatch(FETCH_STORAGE_RECEIPT, this.$route.params.id)
      .then(() => {
        this.$store.dispatch(SET_ACTIONS, {
          buttons: [
            {
              name: "پرینت",
              event: "print-receipt-event",
              class: "btn-primary"
            }
          ]
        });
      });

    this.eventHub.$on("print-receipt-event", () => {
      window.print();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("print-receipt-event");
  },
  computed: {
    ...mapGetters(["storageReceipt"]),

    getFullName() {
      return this.gFullName(this.storageReceipt.user);
    }
  }
};
</script>
